module.exports = __webpack_public_path__ + "img/inlinelogo.8c881c58.png";